import { oz } from '@weft/utils';
import { NotificationSchema } from '../notification';
import { NotificationAlertSchema } from '../notification-alert';

export const ClientNotificationSchema = oz.object({
  notification: NotificationSchema,
  notificationAlert: NotificationAlertSchema,
});

export type ClientNotification = oz.infer<typeof ClientNotificationSchema>;